import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MinichatModule } from './minichat/minichat.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';

import {FooterModule} from './footer/footer';
import {HeaderModule} from './header/header';
import {FeaturesLandingModule} from './features-landing/features-landing';
import {StepsLandingModule} from './steps-landing/steps-landing';
import {PricingLandingModule} from './pricing-landing/pricing-landing';


import { HomepageModule } from './homepage/homepage'
import { DialogCreateRoom } from './homepage/createRoom';
import { FeaturesModule } from './features/features'
import { ContactModule } from './contact/contact'
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

import { HttpClientModule } from '@angular/common/http'; 

import {MatExpansionModule} from '@angular/material/expansion';

/* steps */
import {CdkStepperModule} from '@angular/cdk/stepper';
import {MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
/* end steps */


import {MatListModule} from '@angular/material/list';
import { RouterModule, Router } from '@angular/router';

import {CommonModule } from '@angular/common';


@NgModule({
  declarations: [
    AppComponent,
    DialogCreateRoom,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule,
    AppRoutingModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatExpansionModule,
    MatStepperModule,
    CdkStepperModule,
    MatFormFieldModule,
    FooterModule,
    HeaderModule,
    HomepageModule,
    FeaturesModule,
    ContactModule,
    MinichatModule,
    HttpClientModule,
    FormsModule,
    MatDialogModule,
    FeaturesLandingModule,
    StepsLandingModule,
    PricingLandingModule,
    MatListModule,
    BrowserAnimationsModule
  ],
  entryComponents: [DialogCreateRoom],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
